import 'bootstrap';
import * as $ from "jquery";
import moment from 'moment';

export default (function () {
    let $formContainer = $('.auditlog-search-form');
    
    const dateTimeFormat = 'MM/DD/YYYY HH:mm:00';
    
    if (0 < $formContainer.length) {
        const picker = $('#rangeDateTimePicker');

        picker.daterangepicker(
            {
                ranges: {
                    'Last 15 Minutes': [moment().subtract(15, 'minutes'), moment()],
                    'Last 30 Minutes': [moment().subtract(30, 'minutes'), moment()],
                    'Last Hour': [moment().subtract(1, 'hours'), moment()],
                    'Last 24 Hours': [moment().subtract(24, 'hours'), moment()],
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'Last Year': [moment().subtract(1, 'years'), moment()],
                },
                timePicker: true,
                autoUpdateInput: false,
            }, 
            (start, end, range) => {
                if (range === 'Custom Range') {
                    range = `${start.format(dateTimeFormat)} - ${end.format(dateTimeFormat)}`;
                }
                
                picker.val(range);
            }
        );
    }
}());
